window.addEventListener('DOMContentLoaded', function () {
  'use strict';

  const OPTION_NAME = '選手から選ぶ／オリジナル';
  const ORIGINAL_OPTION_VALUE = 'オリジナルネーム&ナンバー';

  const OPTION_SELECTOR = [`select[name="options[${OPTION_NAME}]"]`, `input[name="options[${OPTION_NAME}]"]`].join(', ');

  let submitButton = document.querySelector('.product-form__submit');

  const nameInput = document.getElementById('name_input');
  const numberInput = document.getElementById('number_input');
  const memberNumberInput = document.getElementById('member_number_input');

  if (!nameInput || !numberInput || !submitButton) {
    return;
  }

  const nameBox = nameInput.closest('.product-form__input');
  const numberBox = numberInput.closest('.product-form__input');

  if (!nameBox || !numberBox) {
    return;
  }

  let isCustomizationValid = true;

  /**
   * 現在選択されているバリエーション値を取得する
   *
   * selectとラジオボタンの両方に対応。
   */
  function getSelectedOptionValue() {
    const select = document.querySelector(`select[name="options[${OPTION_NAME}]"]`);

    if (select) {
      return select.value;
    }

    const checkedInput = document.querySelector(`input[name="options[${OPTION_NAME}]"]:checked`);

    return checkedInput ? checkedInput.value : '';
  }

  /**
   * 現在の購入ボタンを取得する
   *
   * バリエーション変更などで購入ボタンが
   * 再生成された場合にも対応する。
   */
  function refreshSubmitButton() {
    const newSubmitButton = document.querySelector('.product-form__submit');

    if (newSubmitButton) {
      submitButton = newSubmitButton;
    }
  }

  /**
   * 要素を表示する
   */
  function showElement(element) {
    element.classList.remove('hidden');
  }

  /**
   * 要素を非表示にする
   */
  function hideElement(element) {
    element.classList.add('hidden');
  }

  /**
   * 入力欄の有効・無効と必須状態を切り替える
   */
  function setFieldEnabled(field, enabled, required) {
    field.disabled = !enabled;
    field.required = enabled && required;
  }

  /**
   * 全角数字を半角数字に変換し、数字以外を削除する
   */
  function filterNumeric(input) {
    input.value = input.value
      .replace(/[０-９]/g, function (character) {
        return String.fromCharCode(character.charCodeAt(0) - 0xfee0);
      })
      .replace(/[^0-9]/g, '')
      .slice(0, 3);
  }

  /**
   * 全角英字を半角英字に変換する
   *
   * 半角英字と半角スペース以外を削除し、
   * 大文字に変換する。
   */
  function filterAlpha(input) {
    input.value = input.value
      .replace(/[ａ-ｚＡ-Ｚ]/g, function (character) {
        return String.fromCharCode(character.charCodeAt(0) - 0xfee0);
      })
      .replace(/[^a-zA-Z ]/g, '')
      .toUpperCase()
      .slice(0, 12);
  }

  /**
   * FC会員番号を半角英数字7文字に整え、
   * 3-3-1形式でハイフンを挿入する
   */
  function filterMemberNumber(input) {
    const value = input.value
      .replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (character) {
        return String.fromCharCode(character.charCodeAt(0) - 0xfee0);
      })
      .replace(/[^a-zA-Z0-9]/g, '')
      .slice(0, 7);

    const parts = [];

    if (value.length > 0) {
      parts.push(value.slice(0, 3));
    }

    if (value.length > 3) {
      parts.push(value.slice(3, 6));
    }

    if (value.length > 6) {
      parts.push(value.slice(6, 7));
    }

    input.value = parts.join('-');
  }

  /**
   * ネーム・ナンバー入力欄を表示する
   */
  function showOriginalFields() {
    showElement(nameBox);
    showElement(numberBox);

    setFieldEnabled(nameInput, true, true);
    setFieldEnabled(numberInput, true, true);
  }

  /**
   * ネーム・ナンバー入力欄を非表示にする
   */
  function hideOriginalFields() {
    hideElement(nameBox);
    hideElement(numberBox);

    setFieldEnabled(nameInput, false, false);
    setFieldEnabled(numberInput, false, false);

    nameInput.value = '';
    numberInput.value = '';
  }

  /**
   * バリエーションの選択内容に応じて
   * ネーム・ナンバー欄を切り替える
   */
  function updateOptionFields() {
    const optionValue = getSelectedOptionValue();

    if (optionValue === ORIGINAL_OPTION_VALUE) {
      showOriginalFields();
    } else {
      hideOriginalFields();
    }

    updateSubmitState();
  }

  /**
   * ネーム・ナンバーの入力状態を判定する
   */
  function checkCustomizationValidity() {
    const optionValue = getSelectedOptionValue();

    if (optionValue !== ORIGINAL_OPTION_VALUE) {
      return true;
    }

    const isNameValid = !nameInput.disabled && /^[A-Z ]{1,12}$/.test(nameInput.value) && nameInput.value.trim() !== '';

    const isNumberValid = !numberInput.disabled && /^[0-9]{1,3}$/.test(numberInput.value);

    return isNameValid && isNumberValid;
  }

  /**
   * FC会員番号の入力状態を判定する
   */
  function checkMemberNumberValidity() {
    // FC会員番号欄がない商品は判定対象外
    if (!memberNumberInput) {
      return true;
    }

    return /^[A-Za-z0-9]{3}-[A-Za-z0-9]{3}-[A-Za-z0-9]$/.test(memberNumberInput.value);
  }

  /**
   * 購入ボタンの状態を更新する
   */
  function updateSubmitState() {
    refreshSubmitButton();

    if (!submitButton) {
      return;
    }

    isCustomizationValid = checkCustomizationValidity() && checkMemberNumberValidity();

    submitButton.setAttribute('aria-disabled', String(!isCustomizationValid));

    submitButton.classList.toggle('is-customization-disabled', !isCustomizationValid);
  }

  /**
   * バリエーション変更
   *
   * バリエーション要素が再生成されても動作するよう、
   * documentにイベントを設定する。
   */
  document.addEventListener('change', function (event) {
    if (!(event.target instanceof HTMLSelectElement) && !(event.target instanceof HTMLInputElement)) {
      return;
    }

    if (!event.target.matches(OPTION_SELECTOR)) {
      return;
    }

    updateOptionFields();
  });

  /**
   * ナンバー入力
   */
  numberInput.addEventListener('input', function (event) {
    if (event.isComposing) {
      return;
    }

    filterNumeric(numberInput);
    updateSubmitState();
  });

  numberInput.addEventListener('compositionend', function () {
    setTimeout(function () {
      filterNumeric(numberInput);
      updateSubmitState();
    }, 0);
  });

  /**
   * ネーム入力
   */
  nameInput.addEventListener('input', function (event) {
    if (event.isComposing) {
      return;
    }

    filterAlpha(nameInput);
    updateSubmitState();
  });

  nameInput.addEventListener('compositionend', function () {
    setTimeout(function () {
      filterAlpha(nameInput);
      updateSubmitState();
    }, 0);
  });

  /**
   * FC会員番号入力
   */
  if (memberNumberInput) {
    memberNumberInput.addEventListener('input', function (event) {
      if (event.isComposing) {
        return;
      }

      filterMemberNumber(memberNumberInput);
      updateSubmitState();
    });

    memberNumberInput.addEventListener('compositionend', function () {
      setTimeout(function () {
        filterMemberNumber(memberNumberInput);
        updateSubmitState();
      }, 0);
    });
  }

  /**
   * 入力不足時の購入ボタンクリックを防止する
   */
  document.addEventListener(
    'click',
    function (event) {
      const clickedButton = event.target.closest('.product-form__submit');

      if (!clickedButton) {
        return;
      }

      updateSubmitState();

      if (isCustomizationValid) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true,
  );

  /**
   * Enterキーなどによるフォーム送信も防止する
   */
  document.addEventListener(
    'submit',
    function (event) {
      refreshSubmitButton();

      if (!submitButton || event.target !== submitButton.form) {
        return;
      }

      updateSubmitState();

      if (isCustomizationValid) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true,
  );

  /**
   * バリエーション変更などで購入ボタンが
   * 再生成された場合に状態を更新する
   */
  const observer = new MutationObserver(function () {
    const newSubmitButton = document.querySelector('.product-form__submit');

    if (newSubmitButton && newSubmitButton !== submitButton) {
      submitButton = newSubmitButton;
      updateOptionFields();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  /**
   * 初期表示
   */
  updateOptionFields();
});
